module.exports = __webpack_public_path__ + "static/media/looksy-06.15f6fddc.png";